import { combineReducers } from '@reduxjs/toolkit';

import { filtersReducer } from 'modules/ScrAppBookNew/store/filters';
import { newSelectionReducer } from 'modules/ScrAppBookNew/store/selection';
import { newGalleryUiReducer } from 'modules/ScrAppBookNew/store/ui';

export const scrAppBookNewReducer = combineReducers({
  ui: newGalleryUiReducer,
  selection: newSelectionReducer,
  filters: filtersReducer
});
